import React, { Component } from "react";
import { Row, Col } from "react-grid-system";
import MainContent from "../components/mainContent/MainContent";
import Spacing from "../components/common/spacing/Spacing";
import SectionHeading from "../components/sectionHeading/SectionHeading";
import List from "../components/list/List";
import ListItem from "./../components/list/ListItem";
import Sidebar from "./../components/sidebar/Sidebar";
import Header from "../components/header/Heaher";
import Separator from "../components/common/seperator/Separator";
import Media from "../components/media/Media";
import Card from "../components/card/Card";
import CardLabel from "../components/card/CardLabel";
import Users from "../components/users/Users";
import Button from "../components/button/Button";
import CarouselWrap from "../components/carousel/CarouselWrap";
import SmallCarousel from "../components/carousel/SmallCarousel";
import MediumCarousel from "../components/carousel/MediumCarousel";
import LargeCarousel from "../components/carousel/LargeCarousel";
import ThineCarousel from "../components/carousel/ThineCarousel";
import Footer from "../components/footer/Footer";
import { getTending } from "../data/tending";
import { getFollowers } from "../data/followers";
import { getPodcasts } from "../data/podcasts";
import { getUsers } from "../data/users";
import { getCardData } from "../data/cardData";

class HomePage extends Component {
  state = {
    tendings: getTending(),
    followers: getFollowers(),
    podcasts: getPodcasts(),
    users: getUsers(),
    cardData: getCardData(),
  };

  render() {
    const { tendings, followers, podcasts, users, cardData } = this.state;
    return (
      <React.StrictMode>
        <Header />
        <Sidebar />
        <MainContent>
          <Spacing height={36} />
          <Row>
            <Col lg={4}>
              <SectionHeading title="Featured Podcast" />
              <Spacing height={16} />
              <Card
                imgUrl="/images/card_large.jpg"
                altText="Alt text"
                title="How to Make Successful Business Online Without Losing Millions"
                avatar="Team Coco & Earwolf"
                time="5h ago"
                varient="large_card"
              >
                <CardLabel live like="34.4k" />
                <Users users={users} show={3} toolTipText="Brabblers" />
              </Card>
              <Spacing height={30} />
            </Col>
            <Col lg={4}>
              <SectionHeading title="Trending This Week" />
              <Spacing height={16} />
              <List varient="style1">
                {tendings.map((tending) => (
                  <ListItem key={tending.id}>
                    <Media
                      varient="style1"
                      imgUrl={tending.imgUrl}
                      altText={tending.altText}
                      title={tending.title}
                      subtext={tending.subtext}
                    />
                  </ListItem>
                ))}
              </List>
              <Spacing height={30} />
            </Col>
            <Col lg={4}>
              <SectionHeading title="People to Follow" />
              <Spacing height={16} />
              <List varient="style2">
                {followers.map((follower) => (
                  <ListItem key={follower.id}>
                    <Media
                      varient="style2"
                      imgUrl={follower.imgUrl}
                      altText={follower.altText}
                      title={follower.title}
                      follower={follower.follower}
                    />
                  </ListItem>
                ))}
              </List>
              <Spacing height={10} />
            </Col>
          </Row>
          <Separator />
          <Spacing height={26} />
          <Row>
            <Col lg={12}>
              <SectionHeading title="Categories You Might Dig">
                <Button href="#" varient="style1">
                  See All
                </Button>
              </SectionHeading>
              <Spacing height={16} />
              <List varient="style3">
                {podcasts.map((podcasts) => (
                  <ListItem key={podcasts.id}>
                    <Media
                      varient="style3"
                      imgUrl={podcasts.imgUrl}
                      altText={podcasts.altText}
                      title={podcasts.title}
                      podcasts={podcasts.podcasts}
                    />
                  </ListItem>
                ))}
              </List>
            </Col>
          </Row>
          <Spacing height={30} />
          <Separator />
          <Spacing height={26} />
          <SectionHeading title="Small Cards + Arrow Style 1">
            <Button href="#" varient="style1">
              See All
            </Button>
          </SectionHeading>
          <Spacing height={16} />
          <CarouselWrap varient="small_carousel carousel_style2">
            <SmallCarousel>
              {cardData.smallCard.map((card) => (
                <Card
                  key={card.id}
                  imgUrl={card.imgUrl}
                  altText={card.altText}
                  title={card.title}
                  avatar={card.avatar}
                  varient="small_card"
                ></Card>
              ))}
            </SmallCarousel>
          </CarouselWrap>
          <Spacing height={26} />
          <Separator />
          <Spacing height={26} />
          <SectionHeading title="Medium Cards + Arrow Style 2 " />
          <Spacing height={16} />
          <CarouselWrap varient="medium_carousel carousel_style2">
            <MediumCarousel>
              {cardData.mediumCard.map((card) => (
                <Card
                  key={card.id}
                  imgUrl={card.imgUrl}
                  altText={card.altText}
                  title={card.title}
                  avatar={card.avatar}
                  time={card.time}
                  varient="medium_card"
                >
                  <CardLabel like={card.like} />
                  <Users users={users} show={2} toolTipText="Brabblers" />
                </Card>
              ))}
            </MediumCarousel>
          </CarouselWrap>
          <Spacing height={26} />
          <Separator />
          <Spacing height={26} />
          <SectionHeading title="Big Cards + Tooltip" />
          <Spacing height={16} />
          <CarouselWrap varient="large_carousel carousel_style2">
            <LargeCarousel>
              {cardData.largeCard.map((card) => (
                <Card
                  key={card.id}
                  imgUrl={card.imgUrl}
                  altText={card.altText}
                  title={card.title}
                  avatar={card.avatar}
                  time={card.time}
                >
                  <CardLabel live like="12k" />
                  <Users users={users} show={2} toolTipText="Brabblers" />
                </Card>
              ))}
            </LargeCarousel>
          </CarouselWrap>
          <Spacing height={26} />
          <Separator />
          <Spacing height={26} />
          <SectionHeading title="Tiny Cards">
            <Button href="#" varient="style1">
              See All
            </Button>
          </SectionHeading>
          <Spacing height={16} />
          <CarouselWrap varient="thin_carousel carousel_style2">
            <ThineCarousel>
              {cardData.tineCard.map((card) => (
                <Card
                  key={card.id}
                  imgUrl={card.imgUrl}
                  altText={card.altText}
                  title={card.title}
                  avatar={card.avatar}
                  varient="small_card"
                ></Card>
              ))}
            </ThineCarousel>
          </CarouselWrap>
          <Spacing height={75} />
          <Footer />
        </MainContent>
      </React.StrictMode>
    );
  }
}

export default HomePage;
